import React from "react";
import Styles from "./styles.module.sass";

const ModuleCardWidgets = () => {

    const dataSection = [
        {
            title: "Notificaciones",
            subTitle: null,
            url: null,
            target: "_top",
            iconClass: "alerts",
            status: false
        },
        {
            title: "Dudas y aclaraciones",
            subTitle: null,
            url: null,
            target: "_top",
            iconClass: "message",
            status: false
        },
        {
            title: "Reportar un robo o extravío",
            subTitle: null,
            url: null,
            target: "_top",
            iconClass: "callPhone",
            status: false
        },
    ]

    const notifActive = true

    return (
        <div className={Styles?.cardWidgetContent}>
            {dataSection.length > 0 
                ?
                    dataSection?.map((item, index) => (
                        item?.status
                            ?
                                item?.url
                                    ?
                                        <a 
                                            key={index} 
                                            href={item?.url}
                                            target={item?.target}
                                            className={`${Styles?.cardItemWidget} ${Styles?.[item?.iconClass]}`}
                                        >
                                            <span className={notifActive && item?.iconClass === 'alerts' ? Styles?.activeNotif : ""}>{item?.title}</span>
                                            { item?.subTitle && <span>{item?.subTitle}</span> }
                                        </a>
                                    :
                                        <div 
                                            key={index}
                                            className={`${Styles?.cardItemWidget} ${Styles?.[item?.iconClass]}`}
                                        >
                                            <span className={notifActive && item?.iconClass === 'alerts' ? Styles?.activeNotif : ""}>{item?.title}</span> 
                                            { item?.subTitle && <span>{item?.subTitle}</span> }
                                        </div>
                            : null
                    ))
                : null
            }
        </div>
    );
}

export default ModuleCardWidgets